import React, { useEffect, useState } from 'react';
import Header from './Header'; // Import Header component
import Sidebar from './Sidebar'; // Import Sidebar component
import {axiosInstance} from './helper/axiosConfig';
import './CreatePrescription.css'; // Assuming you have a specific CSS for CreateDoctor
import './CreateDoctor.css'; // Assuming you have a specific CSS for CreateDoctor
import './Dashboard.css'; // Consistent dashboard styling
import { faArrowLeft, faCamera, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'; // Import icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate, useParams } from 'react-router-dom'; // Import navigation hooks
import { specialities } from '../data/specialities';
import { districts } from '../data/districts'
import { thanasByDistrict } from '../data/thanasByDistrict';
import toast, { Toaster } from 'react-hot-toast';

const UpdateProfile = () => {
    const [formData, setFormData] = useState({
        title: 'Dr.',
        email: '',
        gender: '',
        full_name: '',
        mobile_number: '',
        bmdc_number: '',
        speaciality: '',
        bio: '',
        user: '',
        profile_pic: null, // For file upload
        visiting_card: null, // For file upload
        address_district: '',
        address_thana: '',
        address_chamber: '',
    });

    const getRandomColor = () => {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    const userInfoString = localStorage.getItem('user-info');
    const userInfo = JSON.parse(userInfoString);

    const [loading, setLoading] = useState(false); // Loading state for the form submission
    const [errors, setErrors] = useState({});
    const [avatarBgColor, setAvatarBgColor] = useState(getRandomColor());
    const [successMessage, setSuccessMessage] = useState('');
    const [profilePreview, setProfilePreview] = useState(null); // For previewing the selected profile image
    const [availableThanas, setAvailableThanas] = useState([]); // State for available thanas based on district
    const history = useNavigate(); // Hook for navigation
    const { id } = useParams(); // Get the patient ID from the URL
    const [visitingPreview, setVisitingPreview] = useState(formData.visiting_card ? `${process.env.REACT_APP_AXIOS_BASE_URL}${formData.visiting_card}` : null);
    const [signaturePreview, setSignaturePreview] = useState(formData.signature ? `${process.env.REACT_APP_AXIOS_BASE_URL}${formData.signature}` : null);
    const [doctorId, setDoctorId] = useState(userInfo.doctor.id);

    useEffect(() => {
      const fetchPatientData = async () => {
        const userInfoString = localStorage.getItem('user-info');
        if (userInfoString) {
          const userInfo = JSON.parse(userInfoString);
          setDoctorId(userInfo.doctor.id);

            try {
              const doctorResponse = await axiosInstance.get(`/api/doctor/${doctorId}/`);
              setFormData(doctorResponse.data);
              console.log("Doctor data: ", doctorResponse.data);
              if (doctorResponse.data.visiting_card) {
                  setVisitingPreview(`${process.env.REACT_APP_AXIOS_BASE_URL}${doctorResponse.data.visiting_card}`);
              } else {
                  setVisitingPreview('');
              }
              setProfilePreview(doctorResponse.data.profile_pic);
              const doctorSettingResponse = await axiosInstance.get(`/api/doctor-setting/${doctorId}/`);
              const doctorSettingData = doctorSettingResponse.data;
              if (doctorSettingData.signature) {
                  setSignaturePreview(`${process.env.REACT_APP_AXIOS_BASE_URL}${doctorSettingData.signature}`);
              } else {
                  setSignaturePreview('');
              }
              setFormData(prevFormData => ({
                ...prevFormData,
                address_district: doctorSettingData.address_district,
                address_thana: doctorSettingData.address_thana,
                signature: doctorSettingData.signature,
              }));
              console.log("The data is ============= ", doctorSettingData);

              setAvailableThanas(thanasByDistrict[doctorSettingData.address_district] || []);
              console.log("Doctor setting data: ", doctorSettingData);
            } catch (error) {
              console.error('Error fetching patient or doctor setting data:', error);
            }
      };

        }
      fetchPatientData();
    }, []);



    // Handle form changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        if (name === 'address_district') {
          setAvailableThanas(thanasByDistrict[value] || []); // Get thanas for the selected district
        }
    };

    // Handle file inputs
    const handleProfileChange = (e) => {
        const { name, files } = e.target;
        const file = files[0];

        if (file && file.type.startsWith('image/')) {
            setFormData({
                ...formData,
                [name]: file,
            });
            setProfilePreview(URL.createObjectURL(file)); // Show a preview of the image
        } else {
            toast.error("Please upload a valid image file.");
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        const file = files[0];

        if (file && file.type.startsWith('image/')) {
            setFormData({
                ...formData,
                [name]: file,
            });

            // Create a local URL for the preview
            const filePreviewUrl = URL.createObjectURL(file);

            // Update preview accordingly
            if (name === 'visiting_card') {
                setVisitingPreview(filePreviewUrl); // For visiting card preview
            } else if (name === 'signature') {
                setSignaturePreview(filePreviewUrl); // For signature preview
            }
            //setProfilePreview(URL.createObjectURL(file)); // Show a preview of the image
        } else {
            toast.error("Please upload a valid image file.");
        }
    };


    const validatePassword = (password) => {
        const minLength = 8;
        const hasNumber = /\d/;
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;

        if (password && password.length && (password.length < minLength || !hasNumber.test(password) || !hasSpecialChar.test(password))) {
            return false;
        }
        return true;
    };


    // Handle form submission (first register user, then create doctor)
    const handleSubmit = async (e) => {
        e.preventDefault();
        //setLoading(true);

        const userPayload = {
            user_id: formData.user,
            password: formData.password,
        };



        if (!formData.full_name) {
          toast.error("Doctor name is required.")
          return;
        }
        if (!formData.email) {
          toast.error('Doctor email is required.');
          return;
        }
        if (!formData.gender) {
          toast.error('Doctor gender is required.');
          return;
        }
        if (!formData.mobile_number) {
          toast.error('Doctor mobile is required.');
          return;
        }
        if (!formData.bmdc_number) {
          toast.error('BMDC number is required.');
          return;
        }
        if (!formData.degree) {
          toast.error('Degree is required.');
          return;
        }

        if (formData.password !== formData.confirmPassword) {
            toast.error('Passwords do not match.');
            return;
        }
        if (!validatePassword(formData.password)) {
            toast.error('Password must be at least 8 characters long and include numbers and special characters.');
            return;
        }


        // if (!formData.full_name) setErrors({full_name: 'Full name is required.'});
        // if (!formData.email) setErrors({email: 'Email is required.'});
        // if (!formData.gender) setErrors({gender: 'Gender is required.'});
        // if (!formData.mobile_number) setErrors({mobile_number: 'Mobile number is required.'});
        // if (!formData.bmdc_number) setErrors({bmdc_number: 'BMDC number is required.'});
        // // if (!formData.password) setErrors({password: 'Password is required'});

        // // Validate password and confirm password match
        // if (formData.password !== formData.confirmPassword) {
        //     setErrors({ password: 'Passwords do not match.' });
        //     return;
        // }

        // if (!formData.full_name) toast.error('Full name is required.', {autoClose: 3000,});
        // if (!formData.email) toast.error('Email is required.', {autoClose: 3000,});
        // if (!formData.gender) toast.error('Gender is required.', {autoClose: 3000,});
        // if (!formData.mobile_number) toast.error('Mobile number is required.', {autoClose: 3000,});
        // if (!formData.bmdc_number) toast.error('BMDC number is required.', {autoClose: 3000,});
        // if (!formData.password) toast.error('Password is required.', {autoClose: 3000,});
        // if (formData.password !== formData.confirmPassword) toast.error('Passwords do not match.', {autoClose: 3000,});


        try {
            // Step 1: Register the user
            if (formData.password && formData.password.length > 0){
              const userResponse = await axiosInstance.post(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/change-password/`, userPayload);
            }
            //const userId = userResponse.data.user_id; // Assuming the response contains the user ID
            // Step 2: Register the doctor using the newly created user ID
            const doctorFormData = new FormData();
            for (let key in formData) {
                if (formData[key] !== null && key !== 'password' && key !== 'confirmPassword') {
                    doctorFormData.append(key, formData[key]);
                }
            }
            // //console.log("this is the form data = ", doctorFormData);
            //doctorFormData.append('user', userId); // Link doctor to user
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            };
            if (doctorId){
              const doctorResponse = await axiosInstance.put(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/doctor/${doctorId}/`, doctorFormData, config);
              // if(doctorResponse && doctorResponse.data && doctorResponse.data.id){
                const doctorSetting = {
                    address_district: formData.address_district,
                    address_thana: formData.address_thana, // Assuming username is the same as email
                    signature: formData.signature,
                    doctor: doctorResponse.data.id,
                };
                const doctorSettingResponse = await axiosInstance.put(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/doctor-setting/${doctorId}/`, doctorSetting, config);
                toast.success("Profile has been updated successfully.");
                //setLoading(false);
                history('/dashboard'); // Redirect after successful creation

              // }
            }
            //setSuccessMessage('Doctor created successfully!');
            setErrors({});
        } catch (error) {
          if (error.response && error.response.data) {
              setErrors(error.response.data); // Set field-level errors
              const errorMessage = error.response.data.message || 'An error occurred. Please try again.';
              toast.error(errorMessage); // Display a global error
          } else {
              toast.error('Something went wrong. Please try again later.');
          }
        }
    };




    //Schedule JSX

    const formatTime = (timeStr) => {
        const [hours, minutes] = timeStr.split(':'); // Split the time string
        const date = new Date();
        date.setHours(hours, minutes);

        return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true }); // 12-hour format
    };

    const [scheduleForm, setScheduleForm] = useState({
        day: '',
        from_time: '',
        to_time: ''
    });

    const [schedules, setSchedules] = useState([]);  // Store all added schedules

    // Handle changes in schedule form inputs
    const handleScheduleChange = (e) => {
        const { name, value } = e.target;
        setScheduleForm({
            ...scheduleForm,
            [name]: value,
        });
    };

    // Add schedule entry
    const addSchedule = async () => {
        if (!scheduleForm.day || !scheduleForm.from_time || !scheduleForm.to_time) {
            toast.error("Please fill out all fields before adding a schedule.");
            return;
        }

        try {
            // Post the schedule to the API
            const response = await axiosInstance.post(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/schedule/`, {
                doctor: doctorId, // Pass the doctor ID
                day: scheduleForm.day,
                from_time: scheduleForm.from_time,
                to_time: scheduleForm.to_time,
            });

            // Update the schedules state with the new entry
            setSchedules((prev) => [...prev, response.data]);

            // Reset the form
            setScheduleForm({ day: '', from_time: '', to_time: '' });
        } catch (error) {
            console.error("Error adding schedule: ", error);
        }
    };

    // Remove schedule entry
    const removeSchedule = async (scheduleId) => {
        try {
            // Call API to delete the schedule
            await axiosInstance.delete(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/schedule/${scheduleId}/`);

            // Remove from the local state
            setSchedules(schedules.filter(schedule => schedule.id !== scheduleId));
            toast.success("Schedule successfully removed.")
        } catch (error) {
            console.error("Error removing schedule: ", error);
        }
    };

    // Fetch all schedules for the doctor on component mount
    useEffect(() => {
        const fetchSchedules = async () => {
            try {
                const response = await axiosInstance.get(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/schedule-doctor/${doctorId}/`);
                setSchedules(response.data);
            } catch (error) {
                console.error("Error fetching schedules: ", error);
            }
        };

        fetchSchedules();
    }, [id]);
    //Finish Schedule JSX



    return (
        <div className="dashboard-container">
            <Sidebar /> {/* Sidebar component */}
            <div className="dashboard-main">
                <Header /> {/* Header component */}
                <div className="content-box create-doctor"> {/* Matching structure with patient page */}

                    {/* Doctor Creation Form */}
                    <div className="patient-details-container create-patient">

                        {/* Doctor Profile Header */}

                        <div className="patient-header">
                            <div className="back-icon-wrapper">
                                <Link to="/dashboard">
                                    <FontAwesomeIcon icon={faArrowLeft} className="back-icon" />
                                </Link>
                            </div>
                            <div className="center-content">
                                <h2 className="profile-name">{formData.title} {formData.full_name}'s Profile</h2>
                                <div className="profile-picture-wrapper">
                                    <label htmlFor="profile-pic-input">
                                        <div
                                            className="profile-picture"
                                            style={{
                                                backgroundColor: avatarBgColor,
                                                width: '80px',
                                                height: '80px',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                color: '#fff',
                                                fontSize: '36px',
                                                fontWeight: 'bold',
                                                backgroundImage: typeof profilePreview === 'string' ? `url(${profilePreview.startsWith('http') ? profilePreview : `${profilePreview}`})` : 'none',
                                                backgroundSize: 'cover',
                                                backgroundPosition: 'center',
                                            }}
                                        >
                                            {/* Show the first character of the name if profile_pic is not available */}
                                            {typeof profilePreview === 'string' && profilePreview ? (
                                                <img
                                                    // Check if profile_pic is already a full URL, otherwise prefix with your base URL
                                                    src={profilePreview.startsWith('http') ? profilePreview : `${process.env.REACT_APP_AXIOS_BASE_URL}${profilePreview}`}
                                                    alt=""
                                                    style={{ borderRadius: '50%', width: '100%', height: '100%' }}
                                                />
                                            ) : (
                                                formData.full_name ? formData.full_name.charAt(0).toUpperCase() : '?'
                                            )}

                                            <FontAwesomeIcon icon={faCamera} className="camera-icon" />
                                        </div>
                                    </label>
                                    <input
                                        id="profile-pic-input"
                                        type="file"
                                        name="profile_pic"
                                        accept="image/*"
                                        style={{ display: 'none' }} // Hide the file input
                                        onChange={handleProfileChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="patient-info-div">
                            <div className="patient-info">
                              <form onSubmit={handleSubmit} className="patient-info-form create-prescription" enctype="multipart/form-data"> {/* Doctor form */}

                                  {/* Title */}
                                  {errors.profile_pic && <span className="text-danger">{errors.profile_pic}</span>}
                                  <div className="form-group">
                                      <input
                                          type="text"
                                          name="title"
                                          value={formData.title}
                                          onChange={handleChange}
                                      />
                                      <label>Title</label>
                                      {errors.title && <span className="text-danger">{errors.title}</span>}
                                  </div>


                                  {/* Full Name */}
                                  <div className="form-group">
                                      <input
                                          type="text"
                                          name="full_name"
                                          placeholder="Enter Doctor'sFull Name"
                                          value={formData.full_name}
                                          onChange={handleChange}
                                          required
                                      />
                                      <label>Full Name <sup>*</sup></label>
                                      {errors.full_name && <span className="text-danger">{errors.full_name}</span>}
                                  </div>

                                  {/* Speciality */}
                                  <div className="form-group row-double">
                                      <select
                                        name="speaciality"
                                        value={formData.speaciality}
                                        onChange={handleChange}
                                        required
                                      >
                                        <option value="">Select Speaciality</option>
                                        {specialities.map((speaciality) => (
                                          <option key={speaciality.value} value={speaciality.label}>
                                            {speaciality.label}
                                          </option>
                                        ))}
                                      </select>
                                      <label>Speciality <sup>*</sup></label>
                                      {errors.speciality && <span className="text-danger">{errors.speciality}</span>}
                                  </div>


                                  {/* Gender */}
                                  <div className="form-group row-double">
                                      <select
                                          name="gender"
                                          value={formData.gender}
                                          placeholder="Select Gender"
                                          onChange={handleChange}
                                          required
                                      >
                                          <option value="">Select Gender</option>
                                          <option value="male">Male</option>
                                          <option value="female">Female</option>
                                          <option value="other">Other</option>
                                      </select>
                                      <label>Gender <sup>*</sup></label>
                                      {errors.gender && <span className="text-danger">{errors.gender}</span>}
                                  </div>

                                  {/* Email */}
                                  <div className="form-group">
                                      <input
                                          disabled
                                          type="email"
                                          name="email"
                                          placeholder="Enter Email Address"
                                          value={formData.email}
                                          onChange={handleChange}
                                          required
                                      />
                                      <label>Email <sup>*</sup></label>
                                      {errors.email && <span className="text-danger">{errors.email}</span>}
                                  </div>


                                  {/* Mobile Number */}
                                  <div className="form-group">
                                      <input
                                          type="text"
                                          name="mobile_number"
                                          placeholder="Enter Mobile Number"
                                          value={formData.mobile_number}
                                          onChange={handleChange}
                                          required
                                      />
                                      <label>Mobile Number <sup>*</sup></label>
                                      {errors.mobile_number && <span className="text-danger">{errors.mobile_number}</span>}
                                  </div>

                                  {/* BMDC Number */}
                                  <div className="form-group">
                                      <input
                                          type="text"
                                          name="bmdc_number"
                                          placeholder="Enter BMDC Number"
                                          value={formData.bmdc_number}
                                          onChange={handleChange}
                                          required
                                      />
                                      <label>BMDC Number <sup>*</sup></label>
                                      {errors.bmdc_number && <span className="text-danger">{errors.bmdc_number}</span>}
                                  </div>

                                  {/* Degree */}
                                  <div className="form-group">
                                      <input
                                          type="text"
                                          name="degree"
                                          placeholder="Enter Degrees with commas"
                                          value={formData.degree}
                                          onChange={handleChange}
                                          required
                                      />
                                      <label>Degree <sup>*</sup></label>
                                      {errors.degree && <span className="text-danger">{errors.degree}</span>}
                                  </div>

                                  {/* Bio */}
                                  <div className="form-group bio">
                                      <textarea
                                          name="bio"
                                          value={formData.bio}
                                          onChange={handleChange}
                                          placeholder="Enter Doctor's experience"
                                          rows="3"
                                      ></textarea>
                                      <label>Experience</label>
                                      {errors.bio && <span className="text-danger">{errors.bio}</span>}
                                  </div>

                                  <h4>Address</h4>
                                    <div className="form-row row-double">
                                      <div className="form-group">
                                        <select
                                          name="address_district"
                                          value={formData.address_district}
                                          onChange={handleChange}
                                        >
                                          <option value="">Select District</option>
                                          {districts.map((district) => (
                                            <option key={district.name} value={district.name}>
                                              {district.name}
                                            </option>
                                          ))}
                                        </select>
                                        <label>District</label>
                                        {errors.address_district && <span className="text-danger">{errors.address_district}</span>}
                                      </div>

                                      <div className="form-group">
                                        <select
                                          name="address_thana"
                                          value={formData.address_thana}
                                          onChange={handleChange}
                                        >
                                          <option value="">Select Thana</option>
                                          {availableThanas.map((thana) => (
                                            <option key={thana} value={thana}>
                                              {thana}
                                            </option>
                                          ))}
                                        </select>
                                        <label>Thana</label>
                                        {errors.address_thana && <span className="text-danger">{errors.address_thana}</span>}
                                      </div>
                                    </div>

                                    {/* address_chamber */}
                                    <div className="form-group bio row-double">
                                        <textarea
                                            name="address_chamber"
                                            value={formData.address_chamber}
                                            onChange={handleChange}
                                            placeholder="Enter Doctor's Chamber Address"
                                            rows="3"
                                        ></textarea>
                                        <label>Chamber Address</label>
                                        {errors.address_chamber && <span className="text-danger">{errors.address_chamber}</span>}
                                    </div>


                                  {/* Visiting Card Upload */}
                                  <h4>Uploads</h4>
                                  <div className="form-group form-image-update upload upload-update">
                                      <input
                                          type="file"
                                          name="visiting_card"
                                          onChange={handleFileChange}
                                          className="form-control-file"
                                          accept="image/*"
                                      />
                                      <label>Upload Visiting Card <sub>(only jpg or png, no special character)</sub></label>
                                      {/* Display the uploaded visiting card image, if available */}
                                      {visitingPreview ? (
                                          <div>
                                              <a href={visitingPreview} title="Visiting Card" target="_blank">
                                                  <img
                                                      src={visitingPreview}
                                                      alt="Visiting Card"
                                                      style={{ width: '100px', height: '100px', objectFit: 'cover', marginTop: '10px' }}
                                                  />
                                              </a>
                                          </div>
                                      ) : (
                                          <span>No visiting card uploaded yet.</span>
                                      )}
                                      {errors.visiting_card && <span className="text-danger">{errors.visiting_card}</span>}
                                  </div>

                                  {/* Signature Upload */}
                                  <div className="form-group form-image-update upload upload-update">
                                      <input
                                          type="file"
                                          name="signature"
                                          onChange={handleFileChange}
                                          className="form-control-file"
                                          accept="image/*"
                                      />
                                      <label>Upload Signature <sub>(only jpg or png, no special character)</sub></label>
                                      {/* Display the uploaded signature image, if available */}
                                      {signaturePreview ? (
                                          <div>
                                              <a href={signaturePreview} title="Signature" target="_blank">
                                                  <img
                                                      src={signaturePreview}
                                                      alt="Signature"
                                                      style={{ width: '100px', height: '100px', objectFit: 'cover', marginTop: '10px' }}
                                                  />
                                              </a>
                                          </div>
                                      ) : (
                                          <span>No signature uploaded yet.</span>
                                      )}
                                      {errors.signature && <span className="text-danger">{errors.signature}</span>}
                                  </div>

                                {/* Availability Schedule */}
                                  <h4>Availability</h4>
                                  <div className="availability-section">
                                      <div className="schedule-form">
                                          <select name="day" value={scheduleForm.day} onChange={handleScheduleChange} className="day-dropdown">
                                              <option value="">Select Day</option>
                                              {["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map((day) => (
                                                  <option value={day} key={day}>{day}</option>
                                              ))}
                                          </select>

                                          <input
                                              type="time"
                                              name="from_time"
                                              value={scheduleForm.from_time}
                                              onChange={handleScheduleChange}
                                              className="time-field"
                                          />

                                          <input
                                              type="time"
                                              name="to_time"
                                              value={scheduleForm.to_time}
                                              onChange={handleScheduleChange}
                                              className="time-field"
                                          />

                                         {/* <a onClick={addSchedule} className="add-schedule-button">
                                              <FontAwesomeIcon icon={faPlus} />
                                          </a>
                                          */}
                                      </div>

                                      <div className="schedule-list">
                                          {schedules.map((schedule, index) => (
                                              <div key={index} className="schedule-entry">
                                                  <span>{schedule.day} -  {formatTime(schedule.from_time)} to  {formatTime(schedule.to_time)}</span>
                                                  <a onClick={() => removeSchedule(schedule.id)} className="remove-schedule-button">
                                                      <FontAwesomeIcon icon={faTrash} />
                                                  </a>
                                              </div>
                                          ))}
                                      </div>
                                  </div>
                                 <div className='form-group float-right mb-0'>
                                  <button
                                    type='button'
                                    onClick={addSchedule}
                                    className='btn btn-primary btn-lg btn-sub medication'
                                  >
                                    + Add Schedule
                                  </button>
                                </div>
                                {/* Finish Availability Schedule */}

                                  {/* Submit Button */}
                                  <div className="form-group submit-button-container">
                                    <button type="submit" className="submit-btn" disabled={loading}>
                                      {loading ? 'Creating...' : '+ Update Profile'}
                                    </button>
                                  </div>

                                  {/* Success Message */}
                                  {successMessage && <div className="alert alert-success mt-3">{successMessage}</div>}
                              </form>
                            </div>
                          </div>
                    </div>
                </div>
                <div className="footer-content">
                    {process.env.REACT_APP_COPYRIGHT_TEXT || "© 2025, Powered by AmarLab"}
                </div>
            </div>
        </div>
    );
};

export default UpdateProfile;
